import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { getTours } from "../../actions/vrtour";

import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import VRTourPostsItem from "../layout/Employers/VRTourPostsItem";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";

const VRTours = ({
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
  getTours,
  vrtour: { tours, tourloading },
}) => {
  const [noValue, setValue] = useState("");
  const [noValueTwo, setValueTwo] = useState("");
  const [showAuthentication, setShowAuthentication] = useState(true);

  useEffect(() => {
    getTours();
  }, [getTours]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.role === "innovator") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavBlue />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className="search-tours">
        <form method="POST" className="form-flex">
          <div className="tour-search-container">
            <div className="label-input">
              <label htmlFor="jobtitle" className="labels blue">
                Tour Description<i className="fas fa-search mx-5 blue"></i>
              </label>
              <div className="input-drop-down">
                <div className="search-input-hidden">
                  <input
                    className="search-input-style"
                    type="text"
                    name="tourdescription"
                    placeholder="Enter Tour Description or Keywords"
                    onChange={(e) => setValue(e.target.value)}
                  />
                </div>
                {noValue && (
                  <div className="tour-location-results">
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-search fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Tour Result</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="label-input">
              <label htmlFor="location" className="labels blue">
                Location<i className="fas fa-location-arrow blue mx-5"></i>
              </label>
              <div className="input-drop-down">
                <div className="search-input-hidden">
                  <input
                    className="search-input-style"
                    type="text"
                    name="locations"
                    placeholder="Enter City, State or Zip Code"
                    onChange={(e) => setValueTwo(e.target.value)}
                  />
                  <button className="tour-search-button background-blue">
                    <i className="fas fa-street-view fa-lg"></i>
                  </button>
                </div>
                {noValueTwo && (
                  <div className="tour-location-results">
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-location-arrow fa-lg drop-down-icon blue"></i>
                      <p className="drop-down-text">Locations</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      <section className="tour-search">
        <div className="tours-container">
          {tours.length > 0 &&
            tours.map((tour) => <VRTourPostsItem key={tour._id} tour={tour} />)}
          {tours && tours.length <= 0 && (
            <p className="empty-content-alt blue">No Tours</p>
          )}
        </div>
      </section>
    </Fragment>
  );
};

VRTours.propTypes = {
  auth: PropTypes.object.isRequired,
  getTours: PropTypes.func.isRequired,
  vrtour: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  vrtour: state.vrtour,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { getTours })(VRTours);
